import { APIRoute } from '@/modules/utils'
import { PricePlan } from '@/data'

export const Route: APIRoute = {
  method: 'POST',
  path: '/v2/prices/coupon',
}

export type Body = PricePlan & {
  discountCode: string
}

export type Response = PricePlan
